import React from "react";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";

function Sucesso() {
  return (
    <AppLayout>
      <div className="verify-container">
        <h2>🎉 Pagamento aprovado!</h2>
        <p>Sua assinatura foi ativada com sucesso. Aproveite todos os recursos!</p>
      </div>
      <Footer />
    </AppLayout>
  );
}

export default Sucesso;
